import useNodesProjectStore from '../stores/useNodesProjectStore';

export function useNodesProjectSelectors() {
  const project = useNodesProjectStore((s) => s.project);
  const projectId = useNodesProjectStore((s) => s.projectId);
  const feedId = useNodesProjectStore((s) => s.feedId);
  const feedTypes = useNodesProjectStore((s) => s.feedTypes);

  const organization = project?.organization;

  return { project, projectId, feedId, feedTypes, organization };
}
